import { render, staticRenderFns } from "./aiAssistant.vue?vue&type=template&id=f9e79b00"
import script from "./aiAssistant.vue?vue&type=script&lang=js"
export * from "./aiAssistant.vue?vue&type=script&lang=js"
import style0 from "./aiAssistant.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_vue-template-compiler@2.7.15_webpack@5.89.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports